export const emailDataTest = 'input-email';
export const emailLabel = 'Adres e-mail';

export const forwardButtonText = 'Dalej';
export const forwardButtonDataTest = 'button-submit-welcome-form';
